import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useListLposQuery } from "../../stock/stockApi";
import { paths } from "../../../routes/paths";
import DashboardSectionCard from "../components/DashboardSectionCard";

// Cash LPOs still open on the paperwork side (2026-11-03): approved, but the goods are
// not stocked in yet (status still APPROVED / PARTIALLY_RECEIVED) or no receipt is
// attached (no INVOICE-kind attachment - hasInvoice). Cash is paid at approval through
// petty cash, so these are money already out with nothing yet to show for it.
const OPEN_STATUSES = ["APPROVED", "PARTIALLY_RECEIVED", "FULLY_RECEIVED"];
const SHOWN = 8;

const fmtMoney = (v) => Number(v || 0).toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const CashLposPendingCard = () => {
  const canView = useHasPermission("Stock.ViewLpo");
  const { selectedBranchId } = useBranchFilter();

  const { data, isFetching } = useListLposQuery(
    { branchId: selectedBranchId ?? undefined, pageSize: 500 },
    { skip: !canView }
  );

  if (!canView) return null;

  const pending = (data?.items || [])
    .filter((l) => l.paymentType === "CASH" && OPEN_STATUSES.includes(l.status))
    .map((l) => ({ ...l, noStockIn: l.status !== "FULLY_RECEIVED", noReceipt: !l.hasInvoice }))
    .filter((l) => l.noStockIn || l.noReceipt)
    .sort((a, b) => dayjs(a.approvedDate || a.lpoDate).valueOf() - dayjs(b.approvedDate || b.lpoDate).valueOf());

  return (
    <div className="col-12 col-xl-4">
      <DashboardSectionCard
        title={`Cash LPOs - stock in / receipt pending${pending.length ? ` (${pending.length})` : ""}`}
        viewAllPath={paths.stockLpos}
        isLoading={isFetching}
        isEmpty={pending.length === 0}
        emptyText="Every cash LPO is stocked in with its receipt attached."
      >
        <ul className="list-unstyled mb-0">
          {pending.slice(0, SHOWN).map((lpo) => (
            <li key={lpo.recordGuid} className="d-flex justify-content-between align-items-start mb-2">
              <div className="me-2">
                <div className="small fw-semibold">{lpo.supplierName}</div>
                <Link to={paths.stockLpoDetail(lpo.recordGuid)} className="small text-muted text-decoration-none">
                  {lpo.lpoNumber}
                </Link>
                <span className="small text-muted"> · {dayjs(lpo.approvedDate || lpo.lpoDate).format("DD MMM")}</span>
                <div className="d-flex flex-wrap gap-1 mt-1">
                  {lpo.noStockIn && <span className="badge bg-warning text-dark">No stock in</span>}
                  {lpo.noReceipt && <span className="badge bg-danger">No receipt</span>}
                </div>
              </div>
              <span className="small fw-semibold text-nowrap">{fmtMoney(lpo.netAmount)}</span>
            </li>
          ))}
        </ul>
        {pending.length > SHOWN && <div className="small text-muted">+ {pending.length - SHOWN} more - oldest shown first</div>}
      </DashboardSectionCard>
    </div>
  );
};

export default CashLposPendingCard;
